<template>
	<page>
		<module>
			<view-list ref="view" work-type="13" selector :view-config="auth('b_asset_return_viewmanage')">
				<template #search>
					<m-search ref="search" :default-data="defaultSearchData">
						<m-search-item label="资产归还单号">
							<c-input name="return_code"></c-input>
						</m-search-item>
                        <m-search-item label="资产领用单号">
                            <c-input name="apply_code"></c-input>
                        </m-search-item>
                        <m-search-item label="领用人">
                            <c-input name="receive_user_name" placeholder="请输入领用人"></c-input>
                        </m-search-item>
                        <m-search-item label="归还人">
                            <c-input name="apply_user_name" placeholder="请输入归还人"></c-input>
                        </m-search-item>
                        <m-search-item label="归还资产">
                            <c-input name="keyword" placeholder="请输入资产编号或名称"></c-input>
                        </m-search-item>
                        <m-search-item label="所属网点">
                            <c-select name="after_sale_outlet_id" async @search="searchOutlet"></c-select>
                        </m-search-item>
						<m-search-item label="状态">
                            <c-select name="apply_status" :options="applyStatusDic"  multiple></c-select>
						</m-search-item>
					</m-search>
				</template>
                <template #operate="{data}">
                    <c-button v-if="auth('b_asset_return_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>

                </template>
                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_asset_return_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>

                <!--资产归还单号-->
                <template #apply_code="{data}">
                    <c-link @click="globalDialog('assetReturnDetail', {props: {id: data.id}})">{{data.apply_code}}</c-link>
                </template>

                <!--状态-->
                <template #apply_status="{data}">
                    <c-state dict="applyStatusDic" :value="data.apply_status"></c-state>
                </template>

                <template #voucher_image_url="{data}">
                    <c-file-list :value="data.voucher_image_url" size="mini"></c-file-list>
                </template>

				<c-table-column
					type="button"
					label="操作"
					width="250"
					button-limit="4"
				>
					<template #default="{data}">
                        <c-table-button icon="tf-detail" @click="globalDialog('assetReturnDetail', {props: {id: data.id}}, $refs.view.$refs.list.update)">查看</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		components: {

        },
		computed: {
			// 获取 dictName 选项数据
			...mapState(['applyStatusDic']),
		},

		data() {
			return {
				defaultSearchData: {

				},
			}
		},

		methods: {
			/*******搜索网点*****************/
			searchOutlet(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'AFTERSALE_OUTLET',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
